module.exports = __webpack_public_path__ + "img/MDC_Pearlstar_gross.23073ed6.png";